import { Entry } from '../Entry'

export function Entry20220524() {
  return (
    <Entry title="24/05/2022 - v3.0.10">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/12603/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
